import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import styled from 'styled-components';

export const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    borderRadius: '5px',
    padding: '0px 0px',
    width: '172px'
  }
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

export default function BusinessListMenu({ id }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleSettings = (e) => {
    e.stopPropagation();
    localStorage.setItem('business_domain', id);
    window.location.href = '/settings?tab=company-info';
  };

  return (
    <div>
      <MoreVertIcon
        className='icon'
        htmlColor='#878787'
        onClick={handleClick}
        aria-controls='customized-menu'
        aria-haspopup='true'
      />

      <StyledMenu
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <ListItemText onClick={handleSettings}>Setting </ListItemText>
      </StyledMenu>
    </div>
  );
}

const ListItemText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 128.86%;
  color: #545454;
  // border-bottom: 1px solid #e1e1e1;
  padding: 12px 11px 17px 12px;
  cursor: pointer;
  &.last {
    color: #e70000;
    border-bottom: 0;
  }
`;
